import { render, staticRenderFns } from "./MenuGuide.vue?vue&type=template&id=2d572c04&scoped=true"
import script from "./MenuGuide.vue?vue&type=script&lang=js"
export * from "./MenuGuide.vue?vue&type=script&lang=js"
import style0 from "./MenuGuide.vue?vue&type=style&index=0&id=2d572c04&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d572c04",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/source/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d572c04')) {
      api.createRecord('2d572c04', component.options)
    } else {
      api.reload('2d572c04', component.options)
    }
    module.hot.accept("./MenuGuide.vue?vue&type=template&id=2d572c04&scoped=true", function () {
      api.rerender('2d572c04', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/newMenu/components/MenuGuide.vue"
export default component.exports